import React, {Component} from 'react'
import ShippingErrorForm from './ShippingErrorForm'
import FileErrorListContainer from "./file-error-lists/FileErrorListContainer"
import { getListShippingCarrier } from '../../../services/api/ShippingCarrierServices'

class ShippingErrorPage extends Component {
    state = {
        listShippingCarrier: [],
    }

    componentDidMount(){
        this.fetchListShippingCarrierError()
    }

    fetchListShippingCarrierError = async () => {
        try {
            const payloadSCE = {
                page: 1,
                limit: 10000,
            }
            const { data, success, message: mess } = await getListShippingCarrier(payloadSCE)
            if (!success) {
                throw new Error(mess)
            }

            const {shippingCarriers = []} = Object.assign({}, data)

            const newShippingCarriersError = shippingCarriers.length > 0 ? shippingCarriers.map(i => ({
                value: i.slug,
                name: i.name,
            })).sort((a, b) => a.name.localeCompare(b.name)) : []

            this.setState({listShippingCarrier: newShippingCarriersError})
        } catch (error) {
            this.setState({
                error: error.message,
            })
        }
    }

    render() {
        const {listShippingCarrier, partner} = this.state

        return (
            <div className="ExportErrorShippingPage">
                <div className="ExportErrorShippingForm">
                    <ShippingErrorForm listShippingCarrier={listShippingCarrier} partner={partner}/>
                </div>
                <div className="ListErrorShipping">
                    <FileErrorListContainer listShippingCarrier={listShippingCarrier} partner={partner}/>
                </div>
            </div>
        )
    }

}

export default ShippingErrorPage